import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import Html from '../../atoms/Html'
import Picture from '../../atoms/Picture'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  justify-content: stretch;
  grid-gap: 1.5rem;
  &:not(:first-child) {
    margin-top: 4rem;
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH4};
  color: ${({ theme }) => theme.colors.arapawa};
  margin: 0;
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH3};
  }
`

const Text = styled(Html)`
  ${({ theme }) => theme.textStyles.textSmall};
  color: ${({ theme }) => theme.colors.arapawa};

  & a {
    color: ${({ theme }) => theme.colors.arapawa};
    text-decoration: underline;
  }

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.textMedium};
  }
`
export const Introduction = styled(Text)``
export const Description = styled(Text)``
export const Figure = styled.figure`
  display: block;
  margin: 0;
`
export const StyledPicture = styled(Picture)`
  &,
  & img {
    display: block;
  }
`
export const MobilePicture = styled(StyledPicture)`
  @media ${mq(sizes.tablet)} {
    display: none;
    &:only-child {
      display: block;
    }
  }
`
export const TabletPicture = styled(StyledPicture)`
  display: none;
  &:first-child,
  &:only-child {
    display: block;
  }
  @media ${mq(sizes.tablet)} {
    display: block;
  }
  @media ${mq(sizes.desktop)} {
    &,
    &:first-child {
      display: none;
    }
    &:only-child {
      display: block;
    }
  }
`
export const DesktopPicture = styled(StyledPicture)`
  display: none;
  &:only-child {
    display: block;
  }
  @media ${mq(sizes.tablet)} {
    ${MobilePicture} + & {
      display: block;
    }
  }
  @media ${mq(sizes.desktop)} {
    display: block;
  }
`

export const Legend = styled.small`
  ${({ theme }) => theme.textStyles.textSmall};
  color: ${({ theme }) => theme.colors.arapawa};
`
